import React, { useState, useEffect } from 'react';
import '../styles/HomePage.scss';

function HomePage() {
    const [data, setData] = useState([]);

    return (
        <div className="web-body">
            {/* <h1>Crispy Chips</h1> */}
            <div className='crispy-video-container'>

                <video className='crispy-video' autoPlay loop muted>
                    <source src="/assets/crispy-vid.mp4" type="video/mp4" />
                    Sorry, your browser doesn't support videos.
                </video>
            </div>
           
            <div className='find-us-text'>
                <h1>Find us at:</h1>
            </div>
            <div className='location-img-wrapper'>
                <img className='location-img' src='/assets/Location-crop.png' />
            </div>

        </div>
    );

}

export default HomePage;
